namespace GeniuzPOS.InventoryReport {
    export interface IcReport06Row {
        Id?: string;
        SkuCode?: string;
        StkUnit?: string;
        PurLeadTime?: number;
        SkuDesc?: string;
        SkuEnDesc?: string;
        QtyOnhand?: number;
        MinStockQty?: number;
        MaxStockQty?: number;
        CatCode?: string;
        CatName?: string;
        SubCat1Code?: string;
        SubCat1Name?: string;
        SubCat2Code?: string;
        SubCat2Name?: string;
        BrandCode?: string;
        BrandName?: string;
        StyleId?: string;
        StyleName?: string;
        ColorId?: string;
        ColorName?: string;
        SizeId?: string;
        SizeName?: string;
        TasteId?: string;
        TasteName?: string;
        MatTypeId?: string;
        MatTypeName?: string;
        SupplId?: string;
        SupplName?: string;
        StockFg?: number;
        ConsignFg?: number;
        ReorderQty?: number;
        ArticleSeasonCode?: string;
        ArticleSeasonName?: string;
        BrandTypeCode?: string;
        BrandTypeName?: string;
        ConceptCode?: string;
        ConceptName?: string;
    }

    export namespace IcReport06Row {
        export const idProperty = 'Id';
        export const nameProperty = 'SkuCode';
        export const localTextPrefix = 'InventoryReport.IcReport06';
        export const deletePermission = '2Inventory:รายงาน:สินค้าคงเหลือ:View';
        export const insertPermission = '2Inventory:รายงาน:สินค้าคงเหลือ:View';
        export const readPermission = '2Inventory:รายงาน:สินค้าคงเหลือ:View';
        export const updatePermission = '2Inventory:รายงาน:สินค้าคงเหลือ:View';

        export declare const enum Fields {
            Id = "Id",
            SkuCode = "SkuCode",
            StkUnit = "StkUnit",
            PurLeadTime = "PurLeadTime",
            SkuDesc = "SkuDesc",
            SkuEnDesc = "SkuEnDesc",
            QtyOnhand = "QtyOnhand",
            MinStockQty = "MinStockQty",
            MaxStockQty = "MaxStockQty",
            CatCode = "CatCode",
            CatName = "CatName",
            SubCat1Code = "SubCat1Code",
            SubCat1Name = "SubCat1Name",
            SubCat2Code = "SubCat2Code",
            SubCat2Name = "SubCat2Name",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            StyleId = "StyleId",
            StyleName = "StyleName",
            ColorId = "ColorId",
            ColorName = "ColorName",
            SizeId = "SizeId",
            SizeName = "SizeName",
            TasteId = "TasteId",
            TasteName = "TasteName",
            MatTypeId = "MatTypeId",
            MatTypeName = "MatTypeName",
            SupplId = "SupplId",
            SupplName = "SupplName",
            StockFg = "StockFg",
            ConsignFg = "ConsignFg",
            ReorderQty = "ReorderQty",
            ArticleSeasonCode = "ArticleSeasonCode",
            ArticleSeasonName = "ArticleSeasonName",
            BrandTypeCode = "BrandTypeCode",
            BrandTypeName = "BrandTypeName",
            ConceptCode = "ConceptCode",
            ConceptName = "ConceptName"
        }
    }
}
